import { createTheme, makeStyles } from '@material-ui/core/styles';
import { grey, red } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: '10px',
  },
  cardBody: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5),
    margin: 0,
    maxHeight: '200px',
    paddingButton: theme.spacing(2),
    paddingTop: theme.spacing(2),
    overflow: 'auto'
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  tableActionButtonIcon: {
    width: '20px',
    height: '20px'
  },
  popover: {
    width: '100%',
    marginTop: '15px'
  },
  paper: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  button: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
}));

export const theme = createTheme({
  typography: {
    fontFamily: [
      'Nunito',
    ].join(','),
  },
  palette: {
    secondary: {
      main: grey[500],
      dark: red[500],
    },
    primary: {
      main: '#43a047',
    },
  },
});

